module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-aside line-top"
  }, [_c('ul', {
    staticClass: "list-group menu-aside"
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/adminpedidos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" "), _c('span', [_vm._v("Pedidos")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "tag": "li",
      "to": "/usuarios",
      "exact": "",
      "active-class": "active"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Usuarios")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "subnav"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/newuser"
    }
  }, [_c('a', [_vm._v("Nuevo usuario")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/invitarusuarios"
    }
  }, [_c('a', [_vm._v("Invitar usuario")])])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "tag": "li",
      "to": "/historialempresa",
      "active-class": "active"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("Historial Empresa")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "tag": "li",
      "to": "/usuarios/liquidaciones",
      "active-class": "active"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("Liquidaciones")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e190a53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/MenuLateralAdmin.vue
// module id = 1140
// module chunks = 5